module.exports = __webpack_public_path__ + "media/images/front/icon_movie_ar_a-a7c31ff8836b0ab9c68344378e34d206.png";